// extracted by mini-css-extract-plugin
export default {"navigationItem":"NavigationItem_navigationItem__4+O8F"};